import { initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  getAuth,
  sendPasswordResetEmail,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence
} from 'firebase/auth';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(config);
const auth = getAuth(app);

// Configurar persistencia - use local persistence for all browsers
// This ensures auth state persists across page refreshes on mobile
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Firebase persistence set to LOCAL');
  })
  .catch((error) => {
    console.error('Error setting persistence:', error);
    // Fallback to session persistence if local fails
    setPersistence(auth, browserSessionPersistence)
      .then(() => {
        console.log('Firebase persistence fallback to SESSION');
      })
      .catch((err) => {
        console.error('Error setting fallback persistence:', err);
      });
  });

// Configurar el proveedor de Google
const provider = new GoogleAuthProvider();

// Standard configuration for all browsers
provider.setCustomParameters({
  prompt: 'select_account'
});

// Configuración para el restablecimiento de contraseña y verificación de email
const currentOrigin = window.location.origin;

const actionCodeSettings = {
  url: currentOrigin + '/new-password',
  handleCodeInApp: false
};

// Configuración específica para verificación de email
// Safari mobile compatibility: use handleCodeInApp: false for better cross-context support
const emailVerificationSettings = {
  url: currentOrigin + '/setup?emailVerified=true',
  handleCodeInApp: false // Better Safari mobile compatibility
};

// Safari mobile detection utility - more precise detection
export const isSafariMobile = () => {
  const userAgent = navigator.userAgent;

  // Check if it's mobile first
  const isMobile = /iPhone|iPad|iPod/i.test(userAgent);

  // Check if it's Safari (not Chrome, not Firefox, not other browsers on iOS)
  const isSafari = /Safari/i.test(userAgent) &&
                   !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent);

  return isMobile && isSafari;
};

export { auth, config, provider, actionCodeSettings, emailVerificationSettings }; 
